import React, { Fragment } from "react";
import { Card, Col, Row } from 'react-bootstrap';
import '../../../../styles/diario.scss'

const Fiscal = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.fiscal.servidor} Matrícula: {props.fiscal.matricula}</Card.Title>
                        <p>Secretaria: {props.fiscal.secretaria}</p>
                        <p>Posição: {props.fiscal.posicao}</p>
                        <p>Objeto: {props.fiscal.objeto}</p>
                        <p>{props.fiscal.referencia} de {props.fiscal.ano}</p> 
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Fiscal;